import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'cv-loader',
  template: `
    <div class="loader" [ngClass]="{ 'loader--overlay': isOverlay }">
      @if (text) {
        <p class="loader__message">{{ text }}</p>
      }
      <p-progressSpinner ariaLabel="loading" styleClass="loader__spinner" strokeWidth="4"></p-progressSpinner>
    </div>
  `,
  styleUrls: ['./screen-loader.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, ProgressSpinnerModule],
})
export class ScreenLoaderComponent {
  @Input() text: string = '';
  @Input() isOverlay: boolean = true;
}
